import { render } from "./PpcBooster.vue?vue&type=template&id=50f6037e&scoped=true"
import script from "./PpcBooster.vue?vue&type=script&lang=js"
export * from "./PpcBooster.vue?vue&type=script&lang=js"

import "./PpcBooster.vue?vue&type=style&index=0&id=50f6037e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f6037e"]])

export default __exports__